import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
})
export class SignOutComponent implements OnInit {
  public isAuthenticated = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (!this.isAuthenticated) {
      window.location.href = environment.oauthRedirectUrl + '/';
    } else {
      this.router.navigate(['/']);
    }
  }
}
